import styled from 'styled-components';
import { Form, SubmitButton,  } from "formik-antd";
import {Checkbox} from "antd"

export const StyledForm = styled(Form)`
    margin-bottom:1rem;
    padding: 1rem;
    border: 1px solid #ececec;
    border-radius: 4px;
`;

export const Button = styled(SubmitButton)`
    margin-top: 1rem;
`;

export const StyledCheckbox = styled(Checkbox)`
    margin: 5px;
`;

export const CheckboxGroup = styled.div`
`;

export const Sider = styled.div`
    padding: 10px;
    width: 25%;
    height: 100%;
    border-right: 1px solid #ececec;
`;

export const Box = styled.div`
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid #ececec;
    border-radius: 4px;
`;

export const InfiniteContainer = styled.div`
  max-height: 300px;
  padding: 8px 24px;
  overflow: auto;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
`;
